module.exports = __webpack_public_path__ + "static/img/patatas-fritas.a9a5a17.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patatas-fritas.gif
// module id = NXX1
// module chunks = 4